import koModuleCommon from './ko/modules/common';
import enModuleCommon from './en/modules/common';
import viModuleCommon from './vi/modules/common';
import zhModuleCommon from './zh/modules/common';
import thModuleCommon from './th/modules/common';

export const enumMessages = {
    ko: {
        components: {
            modules: {
                common: koModuleCommon,
            },
        },
    },
    en: {
        components: {
            modules: {
                common: enModuleCommon,
            },
        },
    },
    vi: {
        components: {
            modules: {
                common: viModuleCommon,
            },
        },
    },
    zh: {
        components: {
            modules: {
                common: zhModuleCommon,
            },
        },
    },
    th: {
        components: {
            modules: {
                common: thModuleCommon,
            },
        },
    },
};
